import { render, staticRenderFns } from "./BookingTabsFinancials.vue?vue&type=template&id=2921584a&scoped=true&"
import script from "./BookingTabsFinancials.vue?vue&type=script&lang=js&"
export * from "./BookingTabsFinancials.vue?vue&type=script&lang=js&"
import style0 from "./BookingTabsFinancials.vue?vue&type=style&index=0&id=2921584a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921584a",
  null
  
)

export default component.exports